module.exports = __webpack_public_path__ + "img/Group 662three.7b3305a3.png";